import { MOVIMENTACOES_LOTE_LIMIT } from '../models/movimentacoes.service.model';

/**
 * Normaliza e deduplica os identificadores enviados em uma ação em lote.
 */
export function normalizeMovimentacoesLoteIds(ids: Array<string | null | undefined>): string[] {
    const normalized = (Array.isArray(ids) ? ids : [])
        .map((id) => `${id ?? ''}`.trim())
        .filter((id) => !!id);

    return Array.from(new Set(normalized));
}

/**
 * Divide os identificadores em fatias respeitando o limite aceito por requisição de lote.
 */
export function chunkMovimentacoesLote(
    ids: Array<string | null | undefined>,
    size: number = MOVIMENTACOES_LOTE_LIMIT
): string[][] {
    const normalized = normalizeMovimentacoesLoteIds(ids);

    if (!normalized.length) {
        return [];
    }

    const chunkSize = Number.isFinite(size) && size > 0
        ? Math.floor(size)
        : MOVIMENTACOES_LOTE_LIMIT;

    const chunks: string[][] = [];

    for (let index = 0; index < normalized.length; index += chunkSize) {
        chunks.push(normalized.slice(index, index + chunkSize));
    }

    return chunks;
}

/**
 * Indica se a quantidade selecionada será processada em mais de uma requisição.
 */
export function isMovimentacoesLoteFatiado(
    quantidade: number,
    size: number = MOVIMENTACOES_LOTE_LIMIT
): boolean {
    return Number(quantidade) > (Number.isFinite(size) && size > 0 ? size : MOVIMENTACOES_LOTE_LIMIT);
}

/**
 * Monta a mensagem exibida quando parte das fatias foi processada antes da falha.
 */
export function buildMovimentacoesLoteParcialMessage(processados: number, total: number): string {
    const processadosLabel = Number(processados) || 0;
    const totalLabel = Number(total) || 0;

    return `${processadosLabel} de ${totalLabel} movimentações foram processadas antes da falha.`;
}
